import type { CodeLanguage } from '../code-block-highlighter';

/** A recorded example as a code block: pretty JSON, or the text as is (sitemaps, robots.txt). */
export function exampleCode(example: unknown): { code: string; language: CodeLanguage } {
  if (typeof example === 'string') return { code: example, language: 'text' };
  return { code: JSON.stringify(example, null, 2), language: 'json' };
}

/** Error statuses go to the errors section; everything below 400 is a response tab. */
export function isErrorStatus(status: string): boolean {
  return Number(status) >= 400;
}
